var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "carousel",
      staticClass: "homepage-carousel owl-carousel owl-theme",
    },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "products-overview",
          class: _vm.zoomClass(index),
        },
        [
          _c("img", {
            attrs: { src: item.image, alt: item.alt, width: "200px" },
          }),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(item.text))]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }